import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Loader.module.scss";
const SIZE_CLASS = {
    sm: styles.sizeSm,
    md: styles.sizeMd,
    lg: styles.sizeLg,
    xl: styles.sizeXl,
};
export const Loader = ({ size = "md", className, ...rest }) => {
    return (_jsx("span", { role: "status", "aria-live": "polite", className: cn(styles.loader, SIZE_CLASS[size], className), ...rest, children: _jsxs("svg", { viewBox: "0 0 36 36", width: "100%", height: "100%", fill: "none", strokeWidth: "3", children: [_jsx("circle", { className: styles.track, cx: "18", cy: "18", r: "14" }), _jsx("circle", { className: styles.head, cx: "18", cy: "18", r: "14" })] }) }));
};
